export const getCommerceQueryInitialState = () => ({
    query: '',
});
